<template>
    <div class="rounded-md bg-yellow-50 border border-yellow-400 p-4 mx-auto max-w-screen-lg mb-8">
        <div class="flex">
            <div class="flex-shrink-0">
                <ExclamationTriangleIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800">Attention needed</h3>
                <div class="mt-2 text-sm text-yellow-700">
                    <p>User has not yet verified their email address. <a href="#" class="underline" @click.prevent="verifyEmailAddress">Verify Manually</a>, or <a href="#" class="underline" @click.prevent="triggerVerifyEmail">Resend Verification Email</a>.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ExclamationTriangleIcon} from "@heroicons/vue/24/solid"
import {useBus} from "../../../../app"
import {inject} from "vue"

export default {
    name: "VerifyEmail",
    components: {
        ExclamationTriangleIcon,
    },
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    emits: ['verified'],
    setup(props, { emit }) {
        const alert = inject('alert')
        const bus = useBus()

        const verifyEmailAddress = () => {
            alert.fire({
                title: 'Manually Validate Email',
                text: `Confirm you wish to manually confirm the email address for ${props.user.email}.`,
                icon: 'question',
                showCancelButton: true,
            })
                .then((selected) => {
                    if (selected.value) {
                        axios.post(route('users.save', props.user.id), { user: { activated: 1 } })
                            .then(response => {
                                emit('verified')
                                bus.$emit('alert.success', 'User has been validated')
                            })
                            .catch(e => {
                                bus.$emit('alert.danger', 'Update failed')
                            })
                    }
                })
        }

        const triggerVerifyEmail = () => {
            alert.fire({
                title: 'Resend Verification Email?',
                text: `Confirm you wish to resend the verification email for ${props.user.email}.`,
                icon: 'question',
                showCancelButton: true,
            })
                .then((selected) => {
                    if (selected.value) {
                        axios.post(route('users.activate', props.user.id))
                            .then(response => {
                                bus.$emit('alert.success', 'Email has been resent')
                            })
                            .catch(e => {
                                bus.$emit('alert.danger', 'Email resend has failed')
                            })
                    }
                })
        }

        return {
            verifyEmailAddress,
            triggerVerifyEmail,
        }
    }
}
</script>

<style scoped>

</style>
